import React, { Component } from 'react';
import { DraggableWindow } from '../DraggableWindow';

import { LayoutContext } from '../../../../modules/ContextModules/LayoutContext';
import { MarkItem } from './MarkItem/MarkItem';

import 點標註圖案Img from './.image/點標註圖案.png'
import 線標註圖案Img from './.image/線標註圖案.png'
import 面標註圖案Img from './.image/面標註圖案.png'
import 清除標註圖案Img from './.image/清除標註圖案.png'
import 管線樣式Img from './.image/管線樣式.png'

import './MarkFunction.css'
export class MarkFunction extends Component {
    static contextType = LayoutContext;
    constructor(props) {
        super(props);

        this.state = {
            isOpenFunc: false,
            funcName: "",
            color: "#FF0000",
            text: "",
            symbol: 點標註圖案Img,
        }

        this.list = [
            {
                name: "點標註",
                icon: 點標註圖案Img,
            },
            {
                name: "線標註",
                icon: 線標註圖案Img,
            },
            {
                name: "面標註",
                icon: 面標註圖案Img,
            },
            {
                name: "清除標註",
                icon: 清除標註圖案Img,
            },
        ]

        this.markNames = [];
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        // window.gMainMap.TerrainView.removeLayer(this.GetCustomMarkLaye());
    }

    /**取得自畫圖層 */
    GetCustomMarkLayer() {
        const CustDrawLayerID = "_CustomMarkLayer";
        try {
            let layer = window.gMainMap.TerrainView.findLayer(CustDrawLayerID);
            if (!layer) {
                layer = window.gMainMap.TerrainView.addCustomLayer(CustDrawLayerID);
            }
            layer.setDepthTest(false);
            return layer;
        } catch (error) {
            return null;
        }

    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <DraggableWindow
                header="標註功能"
                content={this.content()}
                width={this.props.width}
                height={this.props.height}
                defaultPosition={this.props.defaultPosition}
                handleMinimize={this.props.handleMinimize}
                handleCancel={this.props.handleCancel} 
                isShow={this.props.isShow} />
        );
    }

    content() {
        return (<>
            <div className='markFunction'>
                <div className="markItem-box">
                    {
                        this.list.map(item => {
                            if (this.state.isOpenFunc && item.name === this.state.funcName) {
                                return <MarkItem key={item.name} data={item} handleClick={this.handleClick} checked={true} />
                            }
                            return <MarkItem key={item.name} data={item} handleClick={this.handleClick} />
                        })
                    }
                </div>
                {
                    this.state.isOpenFunc ?
                        <div className="markBox">
                            標註顏色:
                            <div>
                                <label id="colorBox" className="markFunction-color-box" style={{ backgroundColor: this.state.color }}>
                                    <input type="color" onChange={(e) => { this.changeColor_OnChange(e); }}
                                        style={{ visibility: "hidden", margin: "0", padding: "3px", width: "230px", borderWidth: "2px" }} />
                                </label>
                            </div>
                            標註文字:
                            <div style={{ marginBottom: "20px" }}>
                                <input type="text" placeholder="請輸入標註文字" onChange={(e) => { this.changeText_OnChange(e); }}
                                    style={{ margin: "0", padding: "3px", width: "230px" }} />
                            </div>
                            {
                                this.state.funcName === "點標註" ?
                                    <>
                                        標註樣式:
                                        <div style={{ marginBottom: "20px" }} className="markFunction-symbol-container">
                                            <img id="pointStyle1" src={管線樣式Img} onClick={(e) => { this.imgActive_OnClick(e) }} />
                                            <img id="pointStyle2" className="active" src={點標註圖案Img} onClick={(e) => { this.imgActive_OnClick(e) }} />
                                            <img id="pointStyle3" src={面標註圖案Img} onClick={(e) => { this.imgActive_OnClick(e) }} />
                                        </div>
                                    </> :
                                    null
                            }
                            <button style={{ marginBottom: "20px" }} onClick={() => { this.doMark_OnClick(); }}>開始輸入</button>
                        </div> : null
                }
            </div>
        </>
        );
    }

    changeColor_OnChange(e) {
        let value = e.target.value;
        this.setState({ color: value });
    }

    changeText_OnChange(e) {
        let text = e.target.value;

        this.setState({ text: text });
    }

    //樣式高亮
    imgActive_OnClick(e) {

        let idName = "pointStyle";
        for (let i = 1; i < 4; i++) {
            document.getElementById(idName + i).classList.remove("active");
        }

        document.getElementById(e.target.id).classList.add("active");

        this.setState({ symbol: e.target.src });
    }

    doMark_OnClick() {
        var layer = this.GetCustomMarkLayer();

        if (layer != null) {
            window.alertify.log("請左鍵點擊圖台開始輸入。");
            window.gMainMap.TerrainView.abortInput();

            var text = this.state.text;
            if (text == "") {
                var number = 1;
                this.markNames.forEach(name => {
                    if (name == (this.state.funcName + number)) {
                        number += 1;
                    }
                })

                text = this.state.funcName + number;
            }

            this.markNames.push(text);
            if (this.state.funcName === "點標註") {
                window.alertify.log("單擊左鍵決定標註點。");
                let callback = function (result) {
                    if (result.success) {
                        var param = {};
                        param.geo = result.geo;
                        param.color = this.state.color;
                        param.opacity = 1;//0.6;
                        param.size = 32;    //大小
                        if (this.state.symbol != "") {
                            param.symbol = this.state.symbol;
                        }
                        param.absHeight = true; //是否為絕對高度
                        param.label = { color: "FFFFFF", text: text, font: "微軟正黑體", size: 20, borderColor: "000000", borderSize: 2 }; //加上文字Label

                        let entity = layer.addPointEntity(param);
                    }
                }.bind(this);
                window.gMainMap.TerrainView.inputSurfacePoint({
                    onCompleted: callback
                });
            }
            else if (this.state.funcName === "線標註") {
                window.alertify.log("單擊左鍵決定線段起點，雙擊左鍵決定線段終點。");

                let callback = function (result) {
                    if (result.success) {
                        var param = {};
                        param.geo = result.geo;
                        param.color = this.state.color;
                        param.opacity = 0.6;
                        param.size = 3;
                        let entity = layer.addSurfacePolylineEntity(param);

                        var label = {};
                        label.geo = result.geo.Center;//幾何
                        var height = window.gMainMap.TerrainView.getHeight(result.geo.Center);
                        label.geo.z = height;
                        label.color = "#FFFFFF";
                        label.text = text;
                        label.font = "微軟正黑體";
                        label.size = 20;
                        label.borderColor = "#000000";
                        label.borderSize = 2;
                        layer.addTextEntity(label);
                    }
                }.bind(this);
                window.gMainMap.TerrainView.inputSurfacePolyline({
                    onCompleted: callback
                });
            }
            else if (this.state.funcName === "面標註") {
                window.alertify.log("單擊左鍵決定範圍起點，雙擊左鍵決定範圍終點。");

                let callback = function (result) {
                    if (result.success) {
                        var param = {};
                        param.geo = result.geo;
                        param.color = this.state.color;
                        param.opacity = 0.6;
                        let entity = layer.addSurfacePolygonSetEntity(param);

                        var label = {};
                        label.geo = result.geo.Center;
                        var height = window.gMainMap.TerrainView.getHeight(result.geo.Center);
                        label.geo.z = height;
                        label.color = "#FFFFFF";
                        label.text = text;
                        label.font = "微軟正黑體";
                        label.size = 20;
                        label.borderColor = "#000000";
                        label.borderSize = 2;
                        layer.addTextEntity(label);
                    }
                }.bind(this);
                window.gMainMap.TerrainView.inputSurfacePolygon({
                    onCompleted: callback
                });
            }
        }
    }

    clearAllMark() {
        if (window.confirm('是否確定要清除所有標註?')) {
            var layer = this.GetCustomMarkLayer();
            layer.removeAllEntity();
            this.markNames = [];
            window.alertify.success("已移除所有標註。");
        }
    }

    handleClick = (data) => {
        let isOpenFunc = this.state.isOpenFunc;
        if (this.state.funcName === data.name) {
            isOpenFunc = !isOpenFunc;
        }
        else {
            isOpenFunc = true;
        }
        switch (data.name) {
            case "點標註": {
                this.setState({ isOpenFunc: isOpenFunc, funcName: "點標註" });
            }
                break;
            case "線標註": {
                this.setState({ isOpenFunc: isOpenFunc, funcName: "線標註" });
            }
                break;
            case "面標註": {
                this.setState({ isOpenFunc: isOpenFunc, funcName: "面標註" });
            }
                break;
            case "清除標註": {
                this.clearAllMark();
                this.setState({ isOpenFunc: false, funcName: "" });
            }
                break;
        }
    }

    //縮小視窗 暫用不到
    minimizeWindow = () => {
        this.state
            .draggableWindowContext
            .markFunction
            .update({
                isOpened: false,
            });
    }
}